import Image from "next/image";
import { Box } from "../Box/Box";
import { Button } from "../Button/Button";
import { Stack } from "../Stack/Stack";
import { Text } from "../Text/Text";
import { VoucherCodeDialog } from "./VoucherCodeDialog/VoucherCodeDialog";

export function VoucherCodeNotLoggedIn({
  code,
  onClick,
  onClickLogin,
}: {
  code: string;
  onClick: () => void;
  onClickLogin: () => void;
}) {
  return (
    <VoucherCodeDialog>
      <Stack space={"5"} align="center">
        <Text font="accent" weight="strong" size="large">
          {code}
        </Text>

        <Image
          src="/images/jetserror.png"
          alt="Error icon"
          width={297}
          height={230}
        />

        <Box display={"flex"} flexDirection={"row"} alignItems="center">
          <Text color="jets-red" size="large" weight="strong" align="center">
            You need to be logged in to use an exclusive code.
          </Text>
        </Box>

        <Box display={"flex"} style={{ gap: "10px" }} width="full">
          <Button onClick={onClick}>Cancel</Button>
          <Button primary onClick={onClickLogin}>
            Log in
          </Button>
        </Box>
      </Stack>
    </VoucherCodeDialog>
  );
}
